import { type ReactNode, useMemo } from 'react'
import classNames from 'classnames'
import { Typography } from 'shared/ui/Typography'
import { DayjsFormats, numberFormat } from 'shared/lib'
import { uiStore } from 'shared/store/uiStore'
import styles from './styles.module.scss'

export type ITotalDueTodayRowProps = {
  title?: ReactNode
  totalValue: number | string
  secondLine?: ReactNode
  nextChargeAmountDollars?: string | null
  nextChargeDate?: string | null
  className?: string
}

export const TotalDueTodayRow = ({
  title = 'Total due today',
  totalValue,
  nextChargeAmountDollars,
  nextChargeDate,
  secondLine,
  className,
}: ITotalDueTodayRowProps) => {
  const total =
    typeof totalValue === 'string'
      ? totalValue
      : numberFormat({
          value: totalValue,
          currency: 'USD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
  const nextChargeLine = useMemo(() => {
    if (
      nextChargeAmountDollars !== null &&
      nextChargeAmountDollars !== undefined &&
      nextChargeDate
    ) {
      const formattedDate = uiStore.dayjs(nextChargeDate).format(DayjsFormats.full6)
      return `Next charge is ${nextChargeAmountDollars} on ${formattedDate}`
    }
    return null
  }, [nextChargeAmountDollars, nextChargeDate])
  const firstLineVariant = secondLine ? 'body-md-regular' : 'body-lg-medium'

  return (
    <div className={classNames(styles.root, className)}>
      <div className={styles.row}>
        <Typography
          ariaLabel={'TotalDueTodayTitle'}
          variant={firstLineVariant}
          color='var(--content-primary-primary)'
        >
          {title}
        </Typography>
        <Typography
          ariaLabel={'TotalDueTodayValue'}
          variant={firstLineVariant}
          color='var(--content-primary-primary)'
        >
          {total}
        </Typography>
      </div>
      {secondLine && secondLine}
      {nextChargeLine && (
        <Typography
          ariaLabel={'Next charge'}
          variant='body-sm-regular'
          color='var(--content-primary-secondary)'
          className={styles.nextChargeLine}
        >
          {nextChargeLine}
        </Typography>
      )}
    </div>
  )
}
